var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Slide } from '@material-ui/core';
import { useState } from 'react';
import { values } from '../../utils';
import { CategoryList } from './CategoryList';
export function Category(_a) {
    var categories = _a.categories, onSelect = _a.onSelect;
    var _b = useState([]), path = _b[0], setPath = _b[1];
    var handleNextClick = function (id) {
        if (id) {
            return setPath(function (prev) { return __spreadArray(__spreadArray([], prev, true), [id], false); });
        }
        return setPath([]);
    };
    var c = path.reduce(function (acc, p) {
        var _a;
        return values(((_a = acc.find(function (c) { return c.id === p; })) === null || _a === void 0 ? void 0 : _a.sub) || acc);
    }, categories);
    return (_jsx("div", { children: path.length > 0 ? (_jsx(Slide, { direction: 'left', in: path.length > 0, mountOnEnter: true, unmountOnExit: true, children: _jsx("div", { children: _jsx(CategoryList, { categories: c, path: path, onNextClick: handleNextClick, onSelect: onSelect }) }) })) : (_jsx(Slide, { direction: 'right', in: path.length === 0, mountOnEnter: true, unmountOnExit: true, children: _jsx("div", { children: _jsx(CategoryList, { categories: c, path: path, onNextClick: handleNextClick, onSelect: onSelect }) }) })) }));
}
//# sourceMappingURL=Category.js.map